import {gsap} from "../LibrariesImport";

export default class BlockGallerySlider {
    static init() {
        let swipers = document.querySelectorAll('.block-gallery-swiper');
        let allSliders = [];

        swipers.forEach( (swiper) => {
            const btnConfig = {duration: 0.5, ease: "power2.out"};
            const prev = swiper.querySelector(".gallery-button-prev");
            const next = swiper.querySelector(".gallery-button-next");
            const arrows = swiper.querySelector(".arrows");

            if (arrows) {
                const svg = arrows.querySelector("svg");
                this.moveBtnPosition = {
                    top: gsap.quickTo(arrows, "top", btnConfig),
                    left: gsap.quickTo(arrows, "left", btnConfig),
                };
            }


            const myswiper = new Swiper(swiper, {
                slidesPerView: "auto",
                grabCursor: true,
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },
                on: {
                    touchStart: () => {
                        gsap.to(arrows, 0.2, {
                            scale: 0.2,
                        });
                    },
                    touchEnd: () => {
                        if (arrows) {
                            gsap.to(arrows, 0.2, {
                                scale: 1,
                            });
                        }
                    },
                    lock: () => {
                        swiper.classList.remove("swiper-is-active");
                    },
                    unlock: () => {
                        swiper.classList.add("swiper-is-active");
                    }
                }
            });

            if (arrows) {
                myswiper.arrows = arrows;
                allSliders.push(myswiper);

                swiper.addEventListener("mouseenter", (e) => {
                    const blockOffset = swiper.getBoundingClientRect();

                    gsap.to(arrows, {
                        scale: 1,
                        opacity: 1,
                        duration: 0.3
                    });

                    this.moveBtnPosition.top(e.clientY - blockOffset.top);
                    this.moveBtnPosition.left(e.clientX - blockOffset.left);
                });

                swiper.addEventListener("mousemove", (e) => {
                    const blockOffset = swiper.getBoundingClientRect();

                    this.moveBtnPosition.top(e.clientY - blockOffset.top);
                    this.moveBtnPosition.left(e.clientX - blockOffset.left);
                });

                swiper.addEventListener("mouseleave", () => {
                    gsap.to(arrows, {
                        scale: 0.5,
                        opacity: 0,
                        duration: 0.3
                    });
                });

                const btns = swiper.querySelectorAll(".gallery-zoom");
                btns.forEach(btn => {
                    btn.addEventListener("mouseenter", (e) => {
                        gsap.to(arrows, 0.2, {
                            opacity: 0,
                            scale: 0,
                            overwrite: "auto",
                        });

                    });

                    btn.addEventListener("mouseleave", () => {
                        gsap.to(arrows, 0.2, {
                            opacity: 1,
                            scale: 1,
                        });

                    });
                });
            }
        });
    }
}
